<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offe-private-health"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="ozel-saglik-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <get-price-section :getPrice="getPrice" />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import getPriceSection from '@/component/categories/GetPriceSection'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import PrivateHealthData from '@/data/category-page-data/PrivateHealthInsurance.js'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'Özel Sağlık Sigortası Fiyatları İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content:
          'En uygun özel sağlık sigortası fiyatları için tıklayın! Bireysel sağlık sigortası ile ortaya çıkabilecek sağlık giderlerinizi güvence altına alın.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'PrivateHealthInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    getPriceSection,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.HEALTH,
      categoryInfo: PrivateHealthData.categoryInfo,
      getPrice: PrivateHealthData.getPrice,
      faqTitle: PrivateHealthData.faqTitle,
      faqTitleDesc: PrivateHealthData.faqTitleDesc,
      questions: PrivateHealthData.questions,
      formData: {
        description: {
          upperText: 'Limitli, Limitsiz',
          title: 'En İyi Özel Sağlık Sigortası Fiyatları',
          bottomText: 'Teklif İsteyin, Uzman Desteği Alın'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title:
          'İnternete Özel İndirimle Özel Sağlık Sigortanızı Almak Çok Kolay!',
        description: 'En İyi Kapsamı, En İyi Fiyata Alın.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Geniş Kapsamlı Hastane Ağı',
            desc:
              'Özel sağlık sigortası ile hem anlaşmalı hastanelerden hem de istediğiniz hastanelerden sağlık hizmeti alın.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'En İyi Şirket Karşılaştırması',
            desc:
              'Özel sağlık sigortası fiyatlarını en iyi şirketlerden karşılaştırın, poliçenizi kolayca oluşturun.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Taksit Seçenekleri',
            desc:
              'İhtiyaca uygun satın alma. İster peşin, ister taksit imkânından yararlanın, sağlık sigortanız güvenceniz olsun.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Sağlık Danışmanı Desteği',
            desc:
              'Sağlık sigortası danışmanlarımız her zaman yanınızda. Danışmanınız satın alma aşamasında ve poliçe döneminiz boyunca en ince ayrıntıları size aktarır.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Özel Sağlık Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
